<template>
  <div class="settings-documents">
    <div class="settings-documents__title">{{ $tr('settings.security.subtitle') }}</div>

    <div class="settings-documents__description">
      {{ $tr('settings.security.description') }}
    </div>

    <div v-if="companyAgreementList && companyAgreementList.length > 0">
      <div v-for="(item, index) in companyAgreementList" :key="index" class="settings-documents__item">
        <div class="settings-documents__row d-flex align-center justify-space-between">
          <div class="settings-documents__index">{{ index + 1 }}{{ $tr('settings.security.indexTitle') }}</div>

          <div class="settings-documents__actions">
            <vbutton
              :disabled="loading_delete"
              :loading="loading_delete"
              class="group"
              color="transparent"
              type="icon"
              icon="icon-bin"
              @click="deleteCompanyAgreement(item.id)"
            />
          </div>
        </div>

        <div class="settings-documents__row">
          <div class="file-wrapper d-block">
            <input readonly type="text" :value="item.url" />
            <input type="file" accept="application/pdf" multiple="multiple" />
          </div>
        </div>

        <div v-for="(name, ind) in item.names" :key="ind" class="settings-documents__row">
          <input
            disabled
            :value="name.name"
            :placeholder="$tr(`settings.security.file.title.${name.language.code}`)"
            type="text"
          />
        </div>
      </div>
    </div>

    <div v-for="(item, index) in forms" :key="index" class="settings-documents__item">
      <v-form
        :id="`companyAgreementForm-${index}`"
        :name="`companyAgreementForm-${index}`"
        class="settings-documents__form"
      >
        <div class="settings-documents__row">
          <div class="settings-documents__index">
            {{ companyAgreementList.length + (index + 1) }}{{ $tr('settings.security.indexTitle') }}
          </div>

          <div class="settings-documents__actions">
            <vbutton class="group" color="transparent" type="icon" icon="icon-bin" @click="removeForm(index)" />
          </div>
        </div>

        <div class="settings-documents__row">
          <div class="file-wrapper">
            <input
              :ref="`companyFileId-${index}`"
              v-model="item.company_file_id"
              type="hidden"
              name="company_file_id"
            />

            <input
              :ref="`formDocLink-${index}`"
              v-model="item.url"
              name="url"
              type="text"
              :placeholder="$tr('settings.security.uploadFile')"
            />

            <input
              :id="`formDocFile-${index}`"
              :ref="`formFileSelector-${index}`"
              v-validate="{
                required: true,
                size: 15000
              }"
              name="docFile"
              type="file"
              accept="application/pdf"
              multiple="multiple"
              @change="upload($event.target.files, index)"
            />

            <div class="actions">
              <label v-if="!item.company_file_id" :for="`formDocFile-${index}`">
                <icon-upload width="31px" height="20px" />
              </label>

              <div v-else class="pointer" @click="reset(index)">
                <icon-close />
              </div>
            </div>
          </div>
        </div>

        <div v-for="(name, idx) in item.names" :key="idx" class="settings-documents__row">
          <input
            v-model="item.names[idx].name"
            name="title_ru"
            type="text"
            :placeholder="$tr(`settings.security.file.title.${name.language_code}`)"
          />
        </div>
      </v-form>
    </div>

    <div class="buttons-group">
      <vbutton
        label="settings.security.addDoc"
        color="grey"
        type="add"
        :disabled="saveDisabled || loading"
        @click="addForm"
      />

      <vbutton
        :disabled="loading || forms.length == 0 || saveDisabled"
        :loading="loading"
        class="vacancy-button"
        label="common.save"
        color="green"
        @click="save"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { isDomainRu } from '@/_helpers/utils.js';

class Form {
  constructor() {
    this.url = '';
    this.company_file_id = null;
    this.names = [
      {
        name: '',
        language_code: 'en'
      }
    ];

    if (isDomainRu) {
      this.names.push({
        name: '',
        language_code: 'ru'
      });
    }
  }
}

export default {
  name: 'SettingsSecurityDocs',

  data() {
    return {
      active_focus: false,
      forms: []
    };
  },

  computed: {
    ...mapState('companySettingsSecurity', ['companyAgreementList', 'loading', 'loading_delete']),

    company() {
      return this.$store.getters['company/one'];
    },

    saveDisabled() {
      for (let i = 0; i < this.forms.length; i++) {
        this.forms[i];

        const url = this.forms[i].url === '';
        const name = this.forms[i].names.some(itemName => {
          return itemName.name === '';
        });

        if (url || name) {
          return true;
        }
      }

      return false;
    }
  },

  mounted() {
    this.fetchCompanyAgreementsList();
    this.addForm();
  },

  methods: {
    ...mapMutations('companySettingsSecurity', ['SET_LOADING']),

    ...mapActions('services', ['saveCompanyImage']),

    ...mapActions('companySettingsSecurity', [
      'fetchCompanyAgreementsList',
      'addCompanyAgreement',
      'updateCompanyAgreement',
      'deleteCompanyAgreement'
    ]),

    async upload(files, index) {
      this.SET_LOADING(true);

      const file = files[0];
      this.forms[index].url = file.name;

      if (!file) {
        return;
      }

      await this.saveCompanyImage({ imageUrl: file })
        .then(data => {
          this.forms[index].company_file_id = data.id;
          this.forms[index].url = data.url;
        })
        .finally(() => {
          this.SET_LOADING(false);
        });
    },

    removeForm(index) {
      this.forms.splice(index, 1);
    },

    reset(id) {
      let filename = `formFileSelector-${id}`;
      this.$refs[filename].value = '';
      this.forms[id].url = '';
      this.forms[id].company_file_id = null;

      if (!/safari/i.test(navigator.userAgent)) {
        this.$refs[filename].type = '';
        this.$refs[filename].type = 'file';
      }
    },

    addForm() {
      this.active_focus = true;
      this.forms.push(new Form());
    },

    save() {
      this.forms.forEach(async item => {
        if (!item.company_file_id) delete item.company_file_id;

        await this.addCompanyAgreement(item)
          .then(() => {
            this.forms = [];
            this.$nextTick().then(() => {
              this.forms.push(new Form());
            });

            this.$noty.success(this.$tr('settings.security.save_success'));
          })
          .catch(() => {
            this.$noty.error(this.$tr('common.error.text'));
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.settings-documents {
  margin-bottom: 150px;
  max-width: 600px;
  position: relative;

  input {
    width: 100%;
  }

  &__title {
    @include mixin-text-header-bigger;
    margin-bottom: 20px;
  }

  &__description {
    @include mixin-text-main;
    margin-bottom: 20px;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  &__item {
    position: relative;
    margin-bottom: 20px;
  }

  &__index {
    @include mixin-text-header-big;
  }
}

.file-wrapper {
  position: relative;
  min-width: 440px;
  width: 100%;
  margin-top: 4px;
  font-size: 15px;
  display: inline-block;

  @media (max-width: 460px) {
    min-width: 240px;
  }

  input[type='text']:read-only {
    pointer-events: none;
    width: 100%;
    border: 1px solid $grey-light;
    height: 40px;

    &.error {
      border-color: $red;
    }

    &:focus,
    &:active {
      border-color: $grey-light;
    }
  }

  .full-width input[type='text'],
  .full-width textarea {
    border-color: $grey-light;
  }

  input:focus,
  textarea:focus {
    border-color: $grey-light;
  }

  input[type='file'] {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;

    + .actions {
      display: block;
      position: absolute;
      right: 1px;
      top: 3px;
      background: #fff;
      width: 45px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      label {
        cursor: pointer;
      }
    }
  }

  input.error {
    + label .icon-upload {
      color: $red-color;
    }
  }

  .error-mobile {
    display: inline-block;
    margin-top: 10px;
    color: $red;
  }
}
</style>
